module.exports = __webpack_public_path__ + "img/success-darkokr.474fd3da.svg";